module.exports = __webpack_public_path__ + "img/button-rg.d2751a0c.png";